export default "/images/settings.svg?f2cdb782074c074b13f3c2f195716ed2";